<div style="max-width:400px; margin:0 auto;">
    <button (click)="selectLanguageSK()">SK</button>
    <button (click)="selectLanguageEN()" style="margin-left:5px;">EN</button>
    <div class="centerDiv">
        <a href="https://www.go4.sk">
            <img src="assets/img/logoGO4.jpg" alt="GO4 kurier logo" width="75" height="75"> 
        </a>
        <a href="https://www.svihajsuhaj.sk">
            <img src="assets/img/logoCSS.jpg" alt="Cyklokurier Svihaj Suhaj logo" width="75" height="75">
        </a>
    </div>



    <app-input-form (newItemEvent)="shipNmrToChild($event)" [langToChild]="lang" (langToParent)="switchLang($event)"></app-input-form>
    <app-show-status [item]="shipNmrFromInput" [langToChild]="lang"></app-show-status>

</div>